import { capitalize } from 'lodash';
import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { ButtonUI } from 'sonata-react-components';
import { CampaignFamilyEnum } from 'sonata-static-storage/lib/schemas/campaign/campaign.schema';

import { MEDIA_CHANNEL_ICONS } from '../MediaChannelSelector/MediaChannelSelector';
import { MediaChannelSelectorModal } from '../MediaChannelSelectorModal/MediaChannelSelectorModal';

import './MediaChannelSelectionSection.scss';

type State = {
  isModalOpened: boolean;
};

type Props = {
  id: string;
  isDisabledChangeChannelButton?: boolean;
  onChange: (value: CampaignFamilyEnum) => void;
  options: CampaignFamilyEnum[];
  value: CampaignFamilyEnum;
};

export const MediaChannelSelectionSection: React.VFC<Props> = ({
  id,
  isDisabledChangeChannelButton = false,
  onChange,
  options,
  value
}) => {
  const { formatMessage } = useIntl();
  const [{ isModalOpened }, setState] = useState<State>({
    isModalOpened: false
  });

  const handleModalToggle = () => {
    setState(prevState => ({
      ...prevState,
      isModalOpened: !prevState.isModalOpened
    }));
  };

  const handleChannelChange = (newValue: CampaignFamilyEnum) => {
    handleModalToggle();
    onChange(newValue);
  };

  return (
    <div className="mediaChannelSection" id={id}>
      <div className="mediaChannelSection__header">
        {formatMessage({
          defaultMessage: 'Media channel',
          id: 'mediaChannelSelection.section.title'
        })}
      </div>
      <div className="mediaChannelSection__content">
        <div className="mediaChannelSection__card">
          <div className="mediaChannelSection__cardHeader">
            <span />
            <div className="mediaChannelSection__cardHeaderTitle">
              <div className="mediaChannelSection__cardHeaderTitleIcon">
                <span className={`fa-lg ${MEDIA_CHANNEL_ICONS[value]}`} />
              </div>
              {formatMessage({
                defaultMessage: capitalize(value),
                id: `mediaChannelSelection.campaignTypes.${value}.title`
              })}
            </div>
          </div>
          <div className="mediaChannelSection__cardSubTitle">
            {formatMessage({
              defaultMessage: `${capitalize(value)} description`,
              id: `mediaChannelSelection.campaignTypes.${value}.subtitle`
            })}
          </div>
          <div className="mediaChannelSection__cardFooter">
            {formatMessage({
              defaultMessage: `${capitalize(value)} footer`,
              id: `mediaChannelSelection.campaignTypes.${value}.footer`
            })}
          </div>
        </div>
        <div className="mediaChannelSection__cardHeaderActions">
          <ButtonUI
            disabled={isDisabledChangeChannelButton}
            icon="fa-regular fa-pen-to-square"
            iconPosition="left"
            id={`editButton-${id}`}
            onClick={handleModalToggle}
            shape="squareRounded"
            size="medium"
            text={formatMessage({
              defaultMessage: 'Change Channel',
              id: 'mediaChannelSelection.section.editButton'
            })}
            type="secondary"
          />
        </div>
      </div>
      {isModalOpened && (
        <MediaChannelSelectorModal
          id={`selectionModal-${id}`}
          isOpen={isModalOpened}
          onClose={handleModalToggle}
          onSubmit={handleChannelChange}
          options={options}
          value={value}
        />
      )}
    </div>
  );
};
